import { render, staticRenderFns } from "./Luopian.vue?vue&type=template&id=29620d41&scoped=true&"
import script from "./Luopian.vue?vue&type=script&lang=js&"
export * from "./Luopian.vue?vue&type=script&lang=js&"
import style0 from "./Luopian.vue?vue&type=style&index=0&id=29620d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29620d41",
  null
  
)

export default component.exports